import { render, staticRenderFns } from "./redPacket.vue?vue&type=template&id=3ab8a955&scoped=true"
import script from "./redPacket.vue?vue&type=script&lang=js"
export * from "./redPacket.vue?vue&type=script&lang=js"
import style0 from "./redPacket.vue?vue&type=style&index=0&id=3ab8a955&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab8a955",
  null
  
)

export default component.exports